<script>
  import {getContext} from 'svelte';
  import {stringify} from 'query-string';
  import copy from 'copy-to-clipboard';
  import {mc} from '@/core';
  import {timeUtil} from '@/helper/time';
  import {userInfo$} from '@/store/user';
  import {PRIZE_COIN_NAME} from '../const';
  import {TRADING_GAME} from '../images';
  import {gameInfo$, gameStatus$} from '../stream';
  import CountDown from './CountDown.svelte';
  import GameProgress from './GameProgress.svelte';
  import lang from '../TradeCompetitionPage.lang';

  const LG = getContext('LG');

  function handleShare() {
    const referralCode = $userInfo$.referralCode;
    const shareText = LG(lang.ImParticipatingIn) + location.origin + location.pathname + '?' + stringify({referralCode});
    if (copy(shareText)) {
      mc.send('toast', 'info', {message: 'Copied'});
      return;
    }
    mc.send('toast', 'error', {message: 'Failed'});
  }
</script>

<style>
  .share {
    position: fixed;
    top: 55%;
    right: 0;
    z-index: 101;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px 0 0 4px;
    border: 1px solid #192434;
    width: 48px;
    height: 48px;
    background: rgba(13, 19, 27, 0.5);
    color: #00f4ff;
  }
  .game-info {
    padding: 40px 0 20px 0;
    width: 100%;
  }
  .game-info-items {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .info-item {
    color: #fff;
  }
  .info-item.middle {
    padding-right: 100px;
  }
  .info-sub-label {
    font-size: 14px;
  }
  .info-label {
    font-size: 18px;
  }
  .info-value {
    font-size: 40px;
  }
  .game-info {
    color: #00e4ff;
  }
  .cup-img {
    margin-right: 20px;
  }
  .game-info-items-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  @media screen and (min-width: 640px) {
    .show-in-pc {
      display: flex;
    }
    .show-in-h5 {
      display: none;
    }
    .info-label {
      padding-bottom: 20px;
    }
  }
  @media screen and (max-width: 640px) {
    .show-in-pc {
      display: none;
    }
    .show-in-h5 {
      display: flex;
    }
    .info-label {
      padding-top: 20px;
    }
  }
</style>

<div class="game-info">
  <div class="share cp" on:click={handleShare}>
    <i class="iconfont">&#xe63a;</i>
  </div>
  <div class="game-info-items show-in-pc">
    <div class="info-item" style="display: flex;">
      <img width="88" height="88" class="cup-img" src={TRADING_GAME.CUP} alt="cup image" />
      <div>
        <div class="info-label">{LG(lang.CurrentPool)}</div>
        <div class="info-value">
          {$gameInfo$.currentPool || 0}
          <span class="info-sub-label">{PRIZE_COIN_NAME}</span>
        </div>
      </div>
    </div>
    <div class="info-item middle">
      <div class="info-label">{LG(lang.ParticipantsCount || 0)}</div>
      <div class="info-value">
        {$gameInfo$.participantCount || 0}
      </div>
    </div>
    <div class="info-item">
      {#if $gameStatus$.isBeforeSignUpStart}
        <div class="info-label">
          {LG(lang.SignUp)}:&nbsp;&nbsp;{timeUtil.formatUTCDateWestPattern($gameInfo$.signUpStartTime)}-{timeUtil.formatUTCDateWestPattern($gameInfo$.signUpEndTime)}(UTC)
        </div>
        <div class="info-value">
          <CountDown endTime={$gameInfo$.signUpStartTime} />
        </div>
      {:else if $gameStatus$.isSignUpStart}
        <div class="info-label">
          {LG(lang.CompetitionStage)}:&nbsp;&nbsp;{timeUtil.formatUTCDateWestPattern($gameInfo$.competitionStartTime)}-{timeUtil.formatUTCDateWestPattern($gameInfo$.competitionEndTime)}(UTC)
        </div>
        <div class="info-value">
          <CountDown endTime={$gameInfo$.competitionStartTime} />
        </div>
      {:else if $gameStatus$.isCompetitionStart}
        <div class="info-label">
          {LG(lang.CompetitionStage)}:&nbsp;&nbsp;{timeUtil.formatUTCDateWestPattern($gameInfo$.competitionStartTime)}-{timeUtil.formatUTCDateWestPattern($gameInfo$.competitionEndTime)}(UTC)
        </div>
        <div class="info-value">
          <CountDown endTime={$gameInfo$.competitionEndTime} />
        </div>
      {:else if $gameStatus$.isCompetitionEnd}
        <div class="info-label">{LG(lang.AwardsStage)}:{timeUtil.formatUTCDateWestPattern($gameInfo$.awardsStartTime)}-{timeUtil.formatUTCDateWestPattern($gameInfo$.awardsEndTime)}(UTC)</div>
        <div class="info-value">
          {LG(lang.TheEnd)}
        </div>
      {/if}
    </div>
  </div>
  <div class="game-info-items-row show-in-h5">
    <div class="info-item">
      <div class="info-label">{LG(lang.CurrentPool)}</div>
      <div class="info-value">
        {$gameInfo$.currentPool || 0}
        <span class="info-sub-label">{PRIZE_COIN_NAME}</span>
      </div>
    </div>
    <div class="info-item tr">
      <div class="info-label">{LG(lang.ParticipantsCount)}</div>
      <div class="info-value" style="text-align: right;">
        {$gameInfo$.participantCount || 0}
      </div>
    </div>
  </div>
  <div class="game-info-items-row show-in-h5">
    <div class="info-item">
      {#if $gameStatus$.isBeforeSignUpStart}
        <div class="info-label">
          {LG(lang.SignUp)}:<br />{timeUtil.formatUTCDateSlash($gameInfo$.signUpStartTime)}-{timeUtil.formatUTCDateSlash($gameInfo$.signUpEndTime)}(UTC)
        </div>
        <div class="info-value">
          <CountDown endTime={$gameInfo$.signUpStartTime} />
        </div>
      {:else if $gameStatus$.isSignUpStart}
        <div class="info-label">
          {LG(lang.CompetitionStage)}:<br />{timeUtil.formatUTCDateSlash($gameInfo$.competitionStartTime)}-{timeUtil.formatUTCDateSlash($gameInfo$.competitionEndTime)}(UTC)
        </div>
        <div class="info-value">
          <CountDown endTime={$gameInfo$.competitionStartTime} />
        </div>
      {:else if $gameStatus$.isCompetitionStart}
        <div class="info-label">
          {LG(lang.CompetitionStage)}:<br />{timeUtil.formatUTCDateSlash($gameInfo$.competitionStartTime)}-{timeUtil.formatUTCDateSlash($gameInfo$.competitionEndTime)}(UTC)
        </div>
        <div class="info-value">
          <CountDown endTime={$gameInfo$.competitionEndTime} />
        </div>
      {:else if $gameStatus$.isCompetitionEnd}
        <div class="info-label">{LG(lang.AwardsStage)}:<br />{timeUtil.formatUTCDateSlash($gameInfo$.awardsStartTime)}-{timeUtil.formatUTCDateSlash($gameInfo$.awardsEndTime)}(UTC)</div>
        <div class="info-value">
          {LG(lang.TheEnd)}
        </div>
      {/if}
    </div>
  </div>
  <GameProgress value={$gameInfo$.participantCount} />
</div>
